
import PhoneEmail from "@/components/email-phone/index.vue";
import Header from "@/components/header/header.vue";
import { reactive, inject, ref } from "vue";
import { useRoute } from "vue-router";
import { Toast } from "vant";
import router from '@/router';
export default {
  components: {
    PhoneEmail,
    Header,
  },
  setup() {
    const passData: any = ref(null);
    const $http: any = inject("$http");
    const route: any = useRoute();
    const isEmail = ref(true);
    let emailName = common.getStorage('user_info').email
    let my_phone = common.getStorage('user_info').phone
    //是修改手机号还是邮箱
    if (route.query.type === "phone") {
      isEmail.value = false;
    }
    //钱包跳转
    const get_walletPage_fn = async () => {
      let res = await $http.get_walletPage({});
      if (res.code === 200) {
        open("POST", res.data.url, res.data.data);
      }
    };
    /**
     * 当前页面form表单提交post数据，跳转lipapay收银台
     * 禁止iframe。safari安全策略问题。
     */
    const open = (verb: any, url: any, data: any) => {
      var form = document.createElement("form");
      form.action = url;
      form.method = verb;
      form.target = "_self";
      if (data) {
        for (var key in data) {
          var input = document.createElement("input");
          input.name = key;
          input.value =
            typeof data[key] === "object"
              ? JSON.stringify(data[key])
              : data[key];
          form.appendChild(input);
        }
      }
      form.style.display = "none";
      document.body.appendChild(form);
      form.submit();
    };
    const submitFn = async () => {
      let parms = {};
      //调用子组件的校验
      if (!passData.value.verifyEmail() || !passData.value.verifyPhone()) {
        if(!passData.value.verify.code) {
          Toast({
            duration: 3000, // 持续展示 toast
            message: 'Please enter the verification code',
          });
          return 
        }
        if (route.query.type === "phone") {
          parms = Object.assign(parms, {
            phone: passData.value.verify.phone,
            country_code: passData.value.country_code,
            captcha: passData.value.verify.code,
          });
          isEmail.value = false;
        } else {
          parms = Object.assign(parms, {
            email: passData.value.verify.email,
            captcha: passData.value.verify.code,
          });
        }
        let res = await $http.bind(parms);
        if (res.code === 200) {
          common.setStorage("user_info",res.data)
          Toast({
            duration: 4000, // 持续展示 toast
            message: res.message,
          });
          if(route.query.is_wallet == 1) {
            // 跳转钱包
            get_walletPage_fn()
            return
          }
          router.go(-1)
        } else {
          Toast({
            duration: 4000, // 持续展示 toast
            message: res.message,
          });
        }
      }
    };
    return {
      submitFn,
      passData,
      isEmail,
      emailName,
      my_phone,
      Toast
    };
  },
};
